// extracted by mini-css-extract-plugin
module.exports = {"box":"SetupError_box__2KdWM","vertical":"SetupError_vertical__nqMO5","text":"SetupError_text__2F0x3","icon":"SetupError_icon__2g05l","container":"SetupError_container__2_U__"};